import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputBase, InputContainer, InputHint, IInputBaseProperties } from "../input";


interface IProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeigetext der Checkbox.
     */
    label?: string,

    /**
     * Setzt einen Hilfetext.
     */
    hint?: string | JSX.Element,

    /**
     * Gibt an ob die Checkbox ausgewählt ist.
     */
    isChecked?: boolean,

    /**
     * Ein Wert der angibt, ob der Wert des Inputs nur lesbar ist.
     */
    isReadOnly?: boolean,

    /**
     * Ein Wert der angibt, ob das Input abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Wird ausgeführt, sobald sich der Wert der Checkbox ändert.
     */
    onCheckedChanged?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export class CheckBox extends React.Component<IProperties>
{
    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var { style, children, label, hint, isChecked, isReadOnly, isDisabled, onCheckedChanged } = this.props;
        var className: string[] = ["checkbox"];

        if (isDisabled)
            className.push("checkbox--disabled");

        return (
            <InputContainer
                alignLeft
                style={{
                    marginBottom: 10,
                    ...style
                }}>
                <label
                    className={className.join(" ")}>
                    <span>{label}</span>
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={onCheckedChanged}
                        readOnly={isReadOnly}
                        disabled={isDisabled} />
                    <span className="checkbox_checkmark">
                        <i className="mdi mdi-18px mdi-check"></i>
                    </span>
                </label>
                {
                    hint &&
                    <InputHint style={{
                        marginLeft: 28,
                    }}>
                        {hint}
                    </InputHint>
                }
            </InputContainer>
        );
    }
}